// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content_box[data-v-f60b9c08] {\n  border: 0px !important;\n}\n", ""]);
// Exports
module.exports = exports;
